import { TimeSpan, PastPresentFuture } from '~/utils/timespan';

export interface IBanner {
  id: string;
  // Cream serializes a banner's solution as a summary object on read (see
  // Solution.get_summary_dict), but create/update payloads send a bare id
  // string — so this is a union, narrowed at the read sites.
  solution?: string | { id: string; name?: string };
  subject: string;
  content: string;
  style: string;
  action_url: string | null;
  action_text: string | null;
  start: string;
  end: string;
  ispublished: boolean;
  busy?: boolean;
  status?: BannerStatus;
}

export type BannerStatus =
  | 'scheduled'
  | 'draft'
  | 'live'
  | 'paused'
  | 'expired';

export type BannerModelGroup = 'current' | 'expired';

type BannerLike = { start: string; end: string; ispublished: boolean };

type I1 = 'published' | 'unpublished';

const STATUS_MATRIX: Readonly<
  Record<I1, Record<PastPresentFuture, BannerStatus>>
> = {
  published: { past: 'expired', present: 'live', future: 'scheduled' },
  unpublished: { past: 'expired', present: 'paused', future: 'draft' },
};

const GROUP_MATRIX: Readonly<Record<BannerStatus, BannerModelGroup>> = {
  draft: 'current',
  expired: 'expired',
  live: 'current',
  paused: 'current',
  scheduled: 'current',
};

export function getStatus(banner: BannerLike): BannerStatus {
  const ts = new TimeSpan(banner.start, banner.end);
  const timeStatus = ts.pastPresentFuture();
  const publishedStatus = banner.ispublished ? 'published' : 'unpublished';
  return STATUS_MATRIX[publishedStatus][timeStatus];
}

export function getGroup(banner: BannerLike): BannerModelGroup {
  return GROUP_MATRIX[getStatus(banner)];
}
